"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaContext = void 0;

var react_1 = require("react");

var css_1 = require("@emotion/css");

var MediaContext_1 = require("./MediaContext");

var camelCase_1 = require("../utils/camelCase");

function useMediaContext() {
  var mediaContext = react_1.useContext(MediaContext_1.MediaContext);

  var getStyles = function getStyles(themeKey, className) {
    var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!(themeKey in mediaContext.style.styles)) {
      throw new Error("\"".concat(themeKey, "\" not found in [").concat(Object.keys(mediaContext.style.styles).join(", "), "]"));
    }

    var styles = mediaContext.style.styles[themeKey](mediaContext.style.theme, flags);

    var getUtilitySelectors = function getUtilitySelectors(flagsObject) {
      if (Object.keys(flagsObject).length) {
        return Object.entries(flagsObject).map(function (key) {
          var objectType = typeof key[1];
          return objectType === "boolean" && key[1] ? "zora-".concat(themeKey, "--").concat(key[0]) : objectType === "string" ? "zora-".concat(themeKey, "__").concat(key[0], "--").concat(camelCase_1.camelCase(key[1])) : "";
        }).join(" ");
      } else {
        return "";
      }
    };

    return {
      className: "".concat(className ? "".concat(className, " ") : "", "zora-").concat(themeKey).concat(mediaContext.style.useDefaultStyles ? " ".concat(css_1.css(styles)) : "", " ").concat(getUtilitySelectors(flags))
    };
  };

  var getString = function getString(stringName) {
    return mediaContext.strings[stringName];
  };

  return _objectSpread(_objectSpread({}, mediaContext), {}, {
    getString: getString,
    getStyles: getStyles
  });
}

exports.useMediaContext = useMediaContext;